type StorageErrorHandler = (error: unknown) => void;

type GetLocalStorageOptions = {
  defaultValue?: string | null;
  onError?: StorageErrorHandler;
};

type StorageWriteOptions = {
  onError?: StorageErrorHandler;
};

export function safeGetLocalStorage(
  key: string,
  { defaultValue = null, onError }: GetLocalStorageOptions = {}
): string | null {
  try {
    if (typeof window === 'undefined') {
      return defaultValue;
    }

    return window.localStorage.getItem(key) ?? defaultValue;
  } catch (error) {
    onError?.(error);
    return defaultValue;
  }
}

export function safeSetLocalStorage(
  key: string,
  value: string,
  { onError }: StorageWriteOptions = {}
): boolean {
  try {
    if (typeof window === 'undefined') {
      return false;
    }

    window.localStorage.setItem(key, value);
    return true;
  } catch (error) {
    onError?.(error);
    return false;
  }
}

export function safeRemoveLocalStorage(
  key: string,
  { onError }: StorageWriteOptions = {}
): boolean {
  try {
    if (typeof window === 'undefined') {
      return false;
    }

    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    onError?.(error);
    return false;
  }
}
